import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../../services/auth.service';
import {
  EsqueciSenhaRequest,
  EsqueciSenhaResponse,
} from '../../../../interfaces/auth/esqueci-senha.interface';
declare var bootstrap: any;
import tippy from 'tippy.js';

@Component({
  selector: 'app-esqueci-senha',
  templateUrl: './esqueci-senha.component.html',
  styleUrls: ['./esqueci-senha.component.css'],
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule],
})
export class EsqueciSenhaComponent implements OnInit {
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private authService: AuthService
  ) {}
  @ViewChild('senhaInfo')
  senhaInfo!: ElementRef;
  @ViewChild('confirmaSenhaInfo')
  confirmaSenhaInfo!: ElementRef;

  private modalCloseHandler: any;
  mostrarCamposCodigo: boolean = false;
  processandoRecuperacao: boolean = false;
  contadorAtivo: boolean = false;
  contadorIntervalo: any;
  tempoRestante: number = 180;
  minutos: number = 3;
  segundos: number = 0;
  processandoReenvio: boolean = false;
  codigoDataValidade: Date | null = null;
  codigoExpirado: boolean = false;
  verificadorExpiracao: any;
  emailBloqueado: boolean = false;
  esqueciSenhaModel: EsqueciSenhaRequest = {
    email: '',
    code: '',
    novaSenha: '',
    repetirNovaSenha: '',
  };

  private regrasHtml = `
    <div class="senha-rules">
      <p class="mb-2">Sua senha deve conter:</p>
      <div class="regra-senha">No mínimo 6 caracteres</div>
      <div class="regra-senha">Ao menos uma letra maiúscula</div>
      <div class="regra-senha">Ao menos uma letra minúscula</div>
      <div class="regra-senha">Ao menos um número</div>
      <div class="regra-senha">Ao menos um caractere especial (!@#$%...)</div>
    </div>
  `;

  ngOnInit(): void {
    const modalElement = document.getElementById('esqueciaSenha');
    if (modalElement) {
      this.modalCloseHandler = () => {
        this.limparDados();
      };

      modalElement.addEventListener('hidden.bs.modal', this.modalCloseHandler);
    }
  }

  ngAfterViewInit() {
    this.verificarEInicializarTooltips();
  }

  ngOnDestroy(): void {
    if (this.contadorIntervalo) {
      clearInterval(this.contadorIntervalo);
    }

    if (this.verificadorExpiracao) {
      clearInterval(this.verificadorExpiracao);
    }

    const modalElement = document.getElementById('esqueciaSenha');
    if (modalElement && this.modalCloseHandler) {
      modalElement.removeEventListener(
        'hidden.bs.modal',
        this.modalCloseHandler
      );
    }

    this.limparDados();
  }

  iniciarContador(): void {
    this.contadorAtivo = true;
    this.tempoRestante = 180; // 3 minutos
    this.atualizarTempoExibido();

    if (this.contadorIntervalo) {
      clearInterval(this.contadorIntervalo);
    }

    this.contadorIntervalo = setInterval(() => {
      this.tempoRestante--;
      this.atualizarTempoExibido();

      if (this.tempoRestante <= 0) {
        this.pararContador();
      }
    }, 1000);
  }

  pararContador(): void {
    this.contadorAtivo = false;
    this.emailBloqueado = false;
    if (this.contadorIntervalo) {
      clearInterval(this.contadorIntervalo);
    }
  }

  atualizarTempoExibido(): void {
    this.minutos = Math.floor(this.tempoRestante / 60);
    this.segundos = this.tempoRestante % 60;
  }

  async reenviarCodigo(): Promise<void> {
    if (!this.validarModalEsqueciSenha()) {
      return;
    }

    this.processandoReenvio = true;
    try {
      const response = (await this.authService.obterCodigoRecuperacao(
        this.esqueciSenhaModel
      )) as EsqueciSenhaResponse;

      if (response && response.validade) {
        this.codigoDataValidade = this.converterDataBrasileira(
          response.validade
        );
        this.codigoExpirado = false;
        this.iniciarVerificacaoExpiracao();
      }

      this.toastr.success('Código reenviado com sucesso!', 'Sucesso');
      this.iniciarContador();
    } catch (error) {
      this.toastr.error('Erro ao reenviar o código', 'Erro');
      console.error('Erro ao reenviar código:', error);
    } finally {
      this.processandoReenvio = false;
    }
  }

  async gerarCodigoRecuperacao(): Promise<void> {
    if (!this.validarModalEsqueciSenha()) {
      return;
    }

    this.processandoRecuperacao = true;
    try {
      const response = (await this.authService.obterCodigoRecuperacao(
        this.esqueciSenhaModel
      )) as EsqueciSenhaResponse;

      if (response && response.validade) {
        this.codigoDataValidade = this.converterDataBrasileira(
          response.validade
        );
        this.codigoExpirado = false;
        this.iniciarVerificacaoExpiracao();
      }

      this.toastr.success('Código enviado para seu email!', 'Sucesso');

      this.mostrarCamposCodigo = true;
      this.emailBloqueado = true;
      document.getElementById('code')!.style.display = 'block';

      this.iniciarContador();
      setTimeout(() => this.verificarEInicializarTooltips(), 300);
    } catch (error) {
      this.toastr.error(
        'Não foi possível enviar o código de recuperação',
        'Erro'
      );
      console.error('Erro ao solicitar código:', error);
    } finally {
      this.processandoRecuperacao = false;
    }
  }

  async trocarSenha() {
    if (!this.validarModalEsqueciSenha(true)) {
      return;
    }

    this.processandoRecuperacao = true;
    try {
      this.esqueciSenhaModel.code = this.esqueciSenhaModel.code.trim();
      await this.authService.recuperarSenha(this.esqueciSenhaModel);
      this.toastr.success('Senha alterada com sucesso', 'Sucesso');

      const modalElement = document.getElementById('esqueciaSenha');
      if (modalElement) {
        const modal = bootstrap.Modal.getInstance(modalElement);
        modal?.hide();
      }

      this.limparDados();
    } catch (error) {
      this.toastr.error('Não foi possível alterar a senha', 'Erro');
    } finally {
      this.processandoRecuperacao = false;
    }
  }

  limparDados(): void {
    this.esqueciSenhaModel = {
      email: '',
      code: '',
      novaSenha: '',
      repetirNovaSenha: '',
    };
    this.mostrarCamposCodigo = false;
    this.emailBloqueado = false;
    document.getElementById('code')!.style.display = 'none';

    this.pararContador();
    this.codigoExpirado = false;
    this.codigoDataValidade = null;

    if (this.verificadorExpiracao) {
      clearInterval(this.verificadorExpiracao);
    }
  }

  validarModalEsqueciSenha(trocarSenha: boolean = false): boolean {
    const senhaRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;

    if (!this.esqueciSenhaModel.email) {
      this.toastr.error('Por favor, informe seu email', 'Erro');
      return false;
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(this.esqueciSenhaModel.email)) {
      this.toastr.error('Formato de email inválido', 'Erro');
      return false;
    }

    if (trocarSenha) {
      if (this.codigoExpirado) {
        this.toastr.error(
          'O código de recuperação expirou. Por favor, solicite um novo código.',
          'Código Expirado'
        );
        return false;
      }

      if (!this.esqueciSenhaModel.code) {
        this.toastr.error(
          'Por favor, informe o código recebido por email',
          'Erro'
        );
        return false;
      }

      if (!this.esqueciSenhaModel.novaSenha) {
        this.toastr.error('Por favor, informe a nova senha', 'Erro');
        return false;
      }

      if (this.esqueciSenhaModel.novaSenha.length < 6) {
        this.toastr.error('A senha deve ter pelo menos 6 caracteres', 'Erro');
        return false;
      }

      if (
        this.esqueciSenhaModel.novaSenha !==
        this.esqueciSenhaModel.repetirNovaSenha
      ) {
        this.toastr.error('As senhas não coincidem', 'Erro');
        return false;
      }

      if (!senhaRegex.test(this.esqueciSenhaModel.novaSenha)) {
        this.toastr.error(
          'A senha deve ter pelo menos 6 caracteres, uma letra maiúscula, uma minúscula e um caractere especial.',
          'Erro'
        );
        return false;
      }
    }
    return true;
  }

  verificarEInicializarTooltips() {
    setTimeout(() => {
      if (this.senhaInfo) {
        tippy(this.senhaInfo.nativeElement, {
          content: this.regrasHtml,
          allowHTML: true,
          placement: 'right',
          arrow: true,
          theme: 'senha-rules',
          maxWidth: 300,
          interactive: true,
        });
      }

      if (this.confirmaSenhaInfo) {
        tippy(this.confirmaSenhaInfo.nativeElement, {
          content: 'Digite a mesma senha novamente para confirmar.',
          placement: 'right',
          arrow: true,
          theme: 'senha-rules',
        });
      }
    }, 200);
  }

  private converterDataBrasileira(dataStr: string): Date {
    const [dataParte, horaParte] = dataStr.split(' ');
    const [dia, mes, anoStr] = dataParte.split('/');
    const [hora, minuto] = horaParte.split(':');

    let ano = parseInt(anoStr);
    if (ano < 100) {
      ano += 2000;
    }

    console.log(`Data convertida: ${dia}/${mes}/${ano} ${hora}:${minuto}`);

    return new Date(
      ano,
      parseInt(mes) - 1,
      parseInt(dia),
      parseInt(hora),
      parseInt(minuto)
    );
  }

  iniciarVerificacaoExpiracao(): void {
    if (this.verificadorExpiracao) {
      clearInterval(this.verificadorExpiracao);
    }

    this.verificarExpiracao();

    this.verificadorExpiracao = setInterval(() => {
      this.verificarExpiracao();
    }, 10000);
  }

  verificarExpiracao(): void {
    if (!this.codigoDataValidade) {
      return;
    }

    const agora = new Date();

    if (agora >= this.codigoDataValidade) {
      this.codigoExpirado = true;
      this.emailBloqueado = false;
      this.pararContador();

      if (this.verificadorExpiracao) {
        clearInterval(this.verificadorExpiracao);
      }
    }
  }
}
